export const PURCHASE_STATUSES = {
  SUCCESS: 0,
  ERROR: 1,
  CANCELLED: 2,
};

export type PurchaseStatus = typeof PURCHASE_STATUSES[keyof typeof PURCHASE_STATUSES];
